import styles from "../../styles/image-upload.module.scss";
import { Icon } from "../../shared/components/core/Icon";
import { AssetsAPI } from "../../providers/AssetsAPI";
import { useState } from "react";
import { v4 as uuid } from "uuid";
export const ImageUpload = ({
    key,
    onImageUpload,
    validateSize,
    height,
    width,
}) => {
    const [loading, setLoading] = useState(false);
    const id = uuid();

    const validateImageSize = file => {
        if (!file) {
            alert({ text: "Arquivo inválido." });
            return false;
        }
    
        try {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const widthImage = img.naturalWidth;
                const heightImage = img.naturalHeight;
                if (widthImage !== width || heightImage !== height) {
                    alert({
                        text: `Dimensões da imagem estão incorretas. Deve ser ${width}x${height}`,
                    });
                    return false;
                }
                sendFile(file);
            };
        } catch (err) {
            alert({ text: "Erro ao processar a imagem." });
            return false;
        }
    };

    const sendFile = async file => {
        const maxFileSize = 5;
        const fileSize = file.size / 1024 / 1024;
        const fileType = file.type;

        if (fileSize > maxFileSize) {
            alert({
                text: `Escolha um arquivo com no máximo ${maxFileSize}MB`,
            });
            return false;
        }

        const pattern = /image-*/;

        if (!fileType.match(pattern)) {
            alert({ text: "Arquivo inválido." });
            return false;
        }

        let reader = new FileReader();
        setLoading(true);

        reader.onload = async readerEvent => {
            const response = await AssetsAPI.PostAssets({
                mime_type: fileType,
                file: readerEvent.target.result.split("base64,")[1],
            });

            onImageUpload(response.getData({}));
            setLoading(false);
        };

        reader.readAsDataURL(file);
    };

    const handleSetImage = async e => {
        const file = e.target.files[0];
        if (validateSize) {
            await validateImageSize(file, width, height);
        } else if (file) {
            sendFile(file);
        }
    };

    return (
        <div className="d-flex align-center">
            <label htmlFor={id} className={styles.customFileInput}>
                {loading ? (
                    <div className={styles.loading}>
                        <span className={styles.loader}></span>
                    </div>
                ) : (
                    <span className={styles.plus}>
                        <Icon name="plus" color="#fff" />
                    </span>
                )}
                <input
                    type="file"
                    id={id}
                    accept="image/*"
                    onChange={e => handleSetImage(e)}
                />
            </label>
        </div>
    );
};
